import React from 'react';
import { Provider } from 'react-redux'
import { ConfigProvider } from 'antd';
import { ConnectedRouter } from 'connected-react-router'
import zh_CN from 'antd/es/locale-provider/zh_CN';
import { HashRouter as Router, Route, Switch, Link } from "react-router-dom";
import moment from 'moment';
import configureStore, { history } from './store'
import AsyncComponent from '@/components/asyncComponent'
import AuthorizedRoute from "./pages/AuthorizedRoute/authorizedRoute";
import 'moment/locale/zh-cn';

const store = configureStore()

const LayoutWrap = AsyncComponent(() => (import('@/pages/LayoutWrap')))
const Login = AsyncComponent(() => (import('@/pages/Login')))
const Login2 = AsyncComponent(() => (import('@/pages/Login/index2.js')))
const NLPSSTPage = AsyncComponent(() => (import('@/pages/NaturalLanguage/NLPSSTPage')))
const EETPage = AsyncComponent(() => (import('@/pages/NaturalLanguage/EETPage')))
const CheckEET = AsyncComponent(() => (import('@/pages/NaturalLanguage/CheckEET')))
const RETPage = AsyncComponent(() => (import('@/pages/NaturalLanguage/RETPage')))
const CheckRET = AsyncComponent(() => (import('@/pages/NaturalLanguage/CheckRET')))
const CCTPage = AsyncComponent(() => (import('@/pages/NaturalLanguage/CCTPage')))
const MCTPage = AsyncComponent(() => (import('@/pages/NaturalLanguage/MCTPage')))
const Page404 = AsyncComponent(() => (import('@/pages/Page404')))


moment.locale('zh-cn');

function App() {
    return (
        <ConfigProvider locale={zh_CN}>
            <Provider store={store}>
                <ConnectedRouter history={history}>
                    <Router>
                        <Switch>
                            <Route path="/LoginEntity" component={Login} history={history} />
                            <Route path="/LoginRelation" component={Login2} history={history} />
                            <AuthorizedRoute pageType='03' path="/HKKS" component={LayoutWrap} history={history} />
                            {/* 自然语言 */}
                            <AuthorizedRoute pageType='NLP' path="/NLPSSTPage/taskId=:taskId" component={NLPSSTPage} />
                            <AuthorizedRoute pageType='NLP' path="/EETPage/taskId=:taskId" component={EETPage} />
                            <AuthorizedRoute pageType='NLP' path="/CheckEETPage/taskId=:taskId" component={CheckEET} />
                            <AuthorizedRoute pageType='NLP' path="/CheckRETPage/taskId=:taskId" component={CheckRET} />
                            <AuthorizedRoute pageType='NLP' path="/RETPage/taskId=:taskId" component={RETPage} />
                            <AuthorizedRoute pageType='NLP' path="/CCTPage/taskId=:taskId,fromTaskId=:fromTaskId" component={CCTPage} />
                            <AuthorizedRoute pageType='NLP' path="/MCTPage/taskId=:taskId,fromTaskId=:fromTaskId" component={MCTPage} />
                            <Route component={Page404} />
                        </Switch>
                    </Router>
                </ConnectedRouter>
            </Provider>
        </ConfigProvider >
    );
}

export default App;
